document.addEventListener('DOMContentLoaded', function () {
  const storageHours = 24;
  const delay = 2000;

  /*
   * JavaScript telt maanden vanaf 0:
   * januari = 0
   * juli = 6
   * augustus = 7
   */
  const vacationStart = new Date(2026, 6, 27, 0, 0, 0);
  const popupEnd = new Date(2026, 7, 10, 0, 0, 0);
  const now = new Date();

  function getPopupContent() {
    if (now >= popupEnd) {
      return null;
    }

    if (now < vacationStart) {
      return {
        phase: 'before-vacation',
        title: 'Wij gaan er even tussenuit',
        text: `
          <p>
            Bestel vóór <strong>maandag 27 juli</strong>, dan verzenden wij
            je bestelling nog vóór onze vakantie.
          </p>

          <p>
            Bestellingen vanaf maandag 27 juli worden weer verzonden
            vanaf <strong>10 augustus</strong>.
          </p>

          <p class="luz-popup__small-text">
            Bedankt voor je begrip en een fijne zomer! 💛
          </p>
        `
      };
    }

    return {
      phase: 'during-vacation',
      title: 'Wij zijn even met vakantie',
      text: `
        <p>
          Bestellingen worden vanaf <strong>10 augustus</strong>
          weer verzonden.
        </p>

        <p>
          Tijdens onze vakantie ontvang je
          <strong>10% korting</strong> met de code:
        </p>

        <div class="luz-popup__discount-code">
          VAKANTIE10
        </div>

        <p class="luz-popup__small-text">
          Bedankt voor je geduld en een fijne zomer! 💛
        </p>
      `
    };
  }

  const content = getPopupContent();

  if (!content) {
    return;
  }

  /*
   * Iedere fase heeft een eigen opslagcode.
   * Daardoor kan het vakantiebericht vanaf 27 juli gewoon verschijnen,
   * ook als de eerdere popup kort daarvoor is gesloten.
   */
  const storageKey =
    'luzVacationPopupClosed-' + content.phase;

  function wasRecentlyClosed() {
    try {
      const closedAt = Number(
        window.localStorage.getItem(storageKey)
      );

      if (!closedAt) {
        return false;
      }

      const expiresAt =
        closedAt + storageHours * 60 * 60 * 1000;

      if (Date.now() < expiresAt) {
        return true;
      }

      window.localStorage.removeItem(storageKey);
      return false;
    } catch (error) {
      return false;
    }
  }

  function rememberClosing() {
    try {
      window.localStorage.setItem(
        storageKey,
        Date.now().toString()
      );
    } catch (error) {
      // De popup blijft ook werken als localStorage niet beschikbaar is.
    }
  }

  function createPopup() {
    if (document.getElementById('LuzVacationPopup')) {
      return;
    }

    const popup = document.createElement('div');

    popup.id = 'LuzVacationPopup';
    popup.className = 'luz-popup';
    popup.setAttribute('aria-hidden', 'true');

    popup.innerHTML = `
      <div
        class="luz-popup__overlay"
        data-luz-popup-close
      ></div>

      <div
        class="luz-popup__modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="LuzPopupTitle"
        tabindex="-1"
      >
        <button
          type="button"
          class="luz-popup__close"
          aria-label="Popup sluiten"
          data-luz-popup-close
        >
          &times;
        </button>

        <div
          class="luz-popup__icon"
          aria-hidden="true"
        >
          ☀️
        </div>

        <h2
          id="LuzPopupTitle"
          class="luz-popup__title"
        >
          ${content.title}
        </h2>

        <div class="luz-popup__text">
          ${content.text}
        </div>

        <button
          type="button"
          class="luz-popup__button"
          data-luz-popup-close
        >
          Verder winkelen
        </button>
      </div>
    `;

    document.body.appendChild(popup);

    const modal = popup.querySelector(
      '.luz-popup__modal'
    );

    const closeElements = popup.querySelectorAll(
      '[data-luz-popup-close]'
    );

    let previouslyFocusedElement = null;

    function openPopup() {
      previouslyFocusedElement = document.activeElement;

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('luz-popup-open');

      window.setTimeout(function () {
        if (modal) {
          modal.focus();
        }
      }, 50);
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('luz-popup-open');

      rememberClosing();

      if (
        previouslyFocusedElement &&
        typeof previouslyFocusedElement.focus === 'function'
      ) {
        previouslyFocusedElement.focus();
      }
    }

    closeElements.forEach(function (element) {
      element.addEventListener('click', closePopup);
    });

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePopup();
      }
    });

    if (!wasRecentlyClosed()) {
      window.setTimeout(openPopup, delay);
    }
  }

  createPopup();
});